import { render, staticRenderFns } from "./HelpArea.vue?vue&type=template&id=0a3171b4&scoped=true&"
import script from "./HelpArea.vue?vue&type=script&lang=js&"
export * from "./HelpArea.vue?vue&type=script&lang=js&"
import style0 from "./HelpArea.vue?vue&type=style&index=0&id=0a3171b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3171b4",
  null
  
)

export default component.exports